import api from '@/services/api';

/**
 * 获取仪表盘统计概览
 */
export function getAdminStatsOverview() {
  return api.get('/admin/stats/overview');
}

/**
 * 获取最近动态
 */
export function getRecentActivities() {
  return api.get('/admin/stats/recent-activities');
}
